import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/ordersetting/remarktemplate/all', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/ordersetting/remarktemplate/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/ordersetting/remarktemplate/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/ordersetting/remarktemplate/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/ordersetting/remarktemplate/update', params,options);

export const up = (params, options) =>
  request.post('/api/v4ward/ordersetting/remarktemplate/up', qs.stringify(params),options);

export const down = (params, options) =>
  request.post('/api/v4ward/ordersetting/remarktemplate/down', qs.stringify(params),options);

  // /v4ward/ordersetting/setting/getSubModuleList

export const getSubModuleList = (params, options) =>
request.get('/api/v4ward/order/execute/getSubModuleList', Object.assign({}, options, { params }))

export const getSubModuleListByOrderFlag = (params, options) =>
    request.get('/api/v4ward/order/execute/getSubModuleListByOrderFlag', Object.assign({}, options, { params }));